import { createSelector } from 'reselect';
import get from 'app/common/lib/get';
import path from 'ramda/es/path';

import config from 'app/config';
import { getIsStudent } from 'app/selectors/user';
import { APP_ACCESS, APP_POLLS, APP_DNEVNIK, APP_CAFETERIA, EXT_YACLASS } from 'app/common/constants/services';
import apps from 'app/components/Subs/applications';

import getAppTranslateIdWithPrefix from '../i18n/getAppTranslateIdWithPrefix';


export default createSelector(
  [
    (_, { id }) => id,
    getIsStudent,
    state => state.apps.data,
    state => state.students.data,
    state => state.apps.subs,
    (_, { t }) => t,
  ],
  (id, isStudent, data, studentsData, subs, t) => {
    const currentOrgType = path([id, 'orgType'], studentsData);

    return (apps
      .filter((app) => {
        // Якласс нет в неподключенных
        if (app === EXT_YACLASS) {
          return false;
        }
        // Приложение "Голосования"
        if (app === APP_POLLS) {
          return false;
        }
        // Проходная не отображается при логине ребенка (в любом заведении)
        if (app === APP_ACCESS && isStudent) {
          return false;
        }
        // Столовая не поддерживается в школе ученика
        // if (app === APP_CAFETERIA && !get(studentsData, [id, 'hasCafeteria'], false)) {
        //   return false;
        // }
        // изменения по столовой от 20.12.19
        // если поддерживается, то теперь всегда будет во включенных, здесь не будет
        // независимо от подписки
        if (app === APP_CAFETERIA && get(studentsData, [id, 'hasCafeteria'], false)) {
          return false;
        }
        // Дневник не поддерживается в школе (любой дневник)
        if (app === APP_DNEVNIK && !get(studentsData, [id, 'hasDnevnik'], false)) {
          return false;
        }
        // или поддерживается, но только внешний (отключаем)
        if (app === APP_DNEVNIK && get(studentsData, [id, 'dnevnikExternalService'], false)) {
          return false;
        }
        // Остальные случаи (нет подписки)
        const subId = get(data, [app, id], null);
        return !(subs[subId]);
      })
      .map(app => ({
        key: app,
        service: app,
        studentId: parseInt(id, 10),
        description: config.descriptions[app],
        settings: app === APP_CAFETERIA ? `/apps/${id}/cafeteria/settings` : '',
        fullName: t(getAppTranslateIdWithPrefix(currentOrgType, app)),
        name: t(getAppTranslateIdWithPrefix(currentOrgType, app), { context: 'short' }),
        type: t(getAppTranslateIdWithPrefix(currentOrgType, app), { context: 'type' }),
      }))
    );
  }
);
